<template>
    <div v-show="show" class="loader col-md-12">
        <fulfilling-bouncing-circle-spinner
            :animation-duration="4000"
            :size="60"
            :color="spinnerColor"
        />
        <span v-if="message" class="message" v-html="message"></span>
    </div>
</template>

<script>
import { FulfillingBouncingCircleSpinner } from 'epic-spinners';

export default {
    name: 'Spinner',
    components: {
        FulfillingBouncingCircleSpinner,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        size: {
            type: Number,
            default: 60,
        },
        color: {
            type: String,
            default: '#23B481',
        },
        duration: {
            type: Number,
            default: 4000,
        },
        message: {
            type: String,
        }
    },
    computed: {
        spinnerColor() {
            return ca.config('branding.spinner_color');
        }
    }
}
</script>

<style lang="scss">
.loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100px;

    font-weight: 600;
    font-size: 25rem;

    width: 100%;

    .message {
        font-size: 1.5rem;
        font-weight: normal;
        font-style: normal;
    }
}
</style>
